<template>
  <generic-loader
    caption="Fetching release note with UAT Jira missing..."
    topMargin="2"
    v-if="isLoading"
  ></generic-loader>
  <v-row v-else-if="!isLoading">
    <v-col sm="12" mt-3>
      <div>
        <v-data-table
          :headers="headers"
          :hide-default-footer="true"
          :items="releaseNoteList"
          class="elevation-0"
          data-cy="widgetUATJira"
          data-test="widgetUATJira"
          disable-pagination
          item-key="id"
          must-sort
        >
          <template v-slot:item="{ item }">
            <tr data-cy="widgetUATJira__item">
              <td>{{ item.id }}</td>
              <td>
                <router-link :to="`/pack/${item.packId}/releaseNote/${item.id}/view`">
                  {{ item.title }}
                </router-link>
              </td>
              <td>{{ item.documentationStatus }}</td>
              <td>{{ item.dateQaStart }}</td>
              <td>{{ item.dateQaEnd }}</td>
              <td>{{ item.uatStart }}</td>
              <td>{{ item.uatEnd }}</td>
              <td>
                <router-link :to="`/pack/${item.packId}/releaseNote/list`">{{ item.packTitle }}</router-link>
              </td>
              <td>{{ item.packStatus }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import releaseNoteApi from "@/api/releaseNote";
import GenericLoader from "@/components/GenericLoader";

export default {
  components: {
    GenericLoader,
  },
  async created() {
    let result;
    this.isLoading = true;
    try {
      result = await releaseNoteApi.missingUatJiraSearch();
      this.releaseNoteList = result;
    } catch (e) {
      console.error(e);
      this.$notifyError("Could not refresh list of release notes.");
    }
    this.isLoading = false;
  },
  data: () => ({
    headers: [
      {
        text: "ID",
        value: "id",
      },
      {
        text: "Release Note Title",
        value: "title",
      },
      {
        text: "Documentation Status",
        value: "documentationStatus",
      },
      {
        text: "QAT Start",
        value: "dateQaStart",
      },
      {
        text: "QAT End",
        value: "dateQaEnd",
      },
      {
        text: "UAT Start",
        value: "uatStart",
      },
      {
        text: "UAT End",
        value: "uatEnd",
      },
      {
        text: "Pack",
        value: "packTitle",
      },
      {
        text: "Pack Status",
        value: "packStatus",
      },
    ],
    isLoading: false,
    releaseNoteList: [],
  }),
  watch: {
    releaseNoteList(val) {
      this.$emit("uatJira", val.length);
    },
  },
};
</script>
